




















































































































































































































































































import correctDialog from "./correctDialog.vue";
import {
  homeworkDetail,
  correctedList,
  homeworkDel,
  homeworkDetailListInter,
  getHomeworkDetailListApi,
  getHomeworkStudentAnswerDetailApi,
  getHomeworkRedoApi,
} from "@/api/homework";
import { Component, Vue } from "vue-property-decorator";
import { dateFormat } from "@/utils/timeFormat";
import audioPlay from "../addAfter/audioPlay.vue";
@Component({
  name: "afterDetails",
  components: {
    audioPlay,
    correctDialog,
  },
})
export default class extends Vue {
  searchInfo: any = {};
  id = 0;
  detailsData = {
    content_list: [],
    be_correct_num: 0,
  }; //总数据
  tableData = []; // 练习明细列表
  page = 1;
  pageSize = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total = 5;
  dialogImageUrl = "";
  dialogVideoUrl = "";
  dialogVisible = false;
  dialogVideo = false;
  correctedListData = [];
  showText: boolean = false;
  showPicture: boolean = false;
  showMP3: boolean = false;
  showMP4: boolean = false;
  showFormSearch: boolean = true;
  showCorrectDialog: boolean = false;
  correctDialogInfo: any = {};
  statusList: object[] = [
    {
      status_id: 1,
      name: "未发布",
    },
    {
      status_id: 2,
      name: "未提交",
    },
    {
      status_id: 3,
      name: "待批改",
    },
    {
      status_id: 4,
      name: "已批改",
    },
    {
      status_id: 5,
      name: "已截止",
    },
  ];
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getDetails(_t.id);
    _t.getCorrectedList(_t.id);
    _t.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
    if (_t.$route.query.h_s_id && _t.$route.query.h_id) {
      _t.correct({
        homework_student_id: Number(_t.$route.query.h_s_id),
        homework_id: Number(_t.$route.query.h_id),
        deadline_status: Number(_t.$route.query.ddl_status),
      });
    }
  }
  newOpen(v: any) {
    window.open(v, "_blank");
  }
  delHomeWork(v: any) {
    this.$confirm(
      "删除后学员提交的练习也会一起删除，且数据无法恢复，确定要删除吗？",
      `删除 - ${v.title}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        homeworkDel({
          homework_ids: [v.homework_id],
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.$router.go(-1);
          }
        });
      })
      .catch(() => {});
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
  }
  correct(val: any) {
    this.showCorrectDialog = true;
    this.correctDialogInfo = val;
  }
  republish(val: any) {
    this.$confirm(
      `确定将练习再次发布给学员 “${val.student.name}”，让学员可以再次上传练习内容，确定要重新发布？`,
      `重新发布 - ${val.homework.title}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        getHomeworkRedoApi({
          homework_student_id: val.homework_student_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: "重发完成",
            });
            this.showCorrectDialog = false;
            this.getList({
              page: this.page,
              pageSize: this.pageSize,
            });
          }
        });
      })
      .catch(() => {});
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      pageSize: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      pageSize: e,
    });
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
  }
  getList(val: { page: number; pageSize: number }) {
    const option: homeworkDetailListInter = {
      page: val.page,
      page_size: val.pageSize,
      homework_id: this.id,
      include_unpublished: true,
    };
    if (this.searchInfo.status) {
      option.status = this.searchInfo.status;
    }
    if (this.searchInfo.sort_type) {
      option.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field) {
      option.sort_field = this.searchInfo.sort_field;
    }
    getHomeworkDetailListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((it: any) => {
          it.committed_time =
            it.committed_time !== 0
              ? dateFormat("YYYY-mm-dd HH:MM", it.committed_time * 1000)
              : "-";
          it.corrected_time =
            it.corrected_time !== 0
              ? dateFormat("YYYY-mm-dd HH:MM", it.corrected_time * 1000)
              : "-";
        });
        this.total = res.data.total;
        this.tableData = res.data.list;
      }
    });
  }
  play(e: any) {
    const _t = this as any;
    if (e.annex_type == 1) {
      _t.dialogImageUrl = e.annex_content;
      _t.dialogVisible = true;
    } else if (e.annex_type == 2) {
      _t.dialogVideoUrl = e.annex_content;
      _t.dialogVideo = true;
    }
  }
  setTime(a: any) {
    return dateFormat("YYYY-mm-dd HH:MM", new Date(Number(a + "000")));
  }
  getDetails(id: number) {
    const _t = this as any;
    homeworkDetail({ homework_id: id }).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.content_list.length > 0) {
          res.data.audioList = res.data.content_list.reduce(
            (a: any, b: any) => {
              if (b.annex_type == 4) {
                b.url = b.annex_content;
                a.push(b);
              }
              return a;
            },
            []
          );
        }
        res.data.content_list.map((item: any) => {
          if (item.annex_type === 1) {
            this.showPicture = true;
          } else if (item.annex_type === 2) {
            this.showMP4 = true;
          } else if (item.annex_type === 3) {
            this.showText = true;
          } else if (item.annex_type === 4) {
            this.showMP3 = true;
          }
        });
        _t.detailsData = res.data;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  getCorrectedList(id: number) {
    const _t = this as any;
    correctedList({ homework_id: id }).then((res: any) => {
      if (res.error_code == 0) {
        _t.correctedListData = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
}
